import { DatePicker, Button, Space, Divider } from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DateRangeFilter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
  const handleChange = (dates) => {
    if (dates && dates.length === 2) {
      setSelectedKeys(dates);
    } else {
      setSelectedKeys([]);
    }
  };

  const handleReset = () => {
    setSelectedKeys([]);
    clearFilters();
    confirm();
  };

  const handleApply = () => {
    if (selectedKeys && selectedKeys.length === 2) {
      confirm();
    }
  };

  const isDisabled = !selectedKeys || selectedKeys.length !== 2;

  return (
    <div style={{ padding: 16, width: 300 }}>
      <div style={{ marginBottom: 12, fontWeight: 500, color: "#333" }}>
        <FilterOutlined style={{ marginRight: 8 }} />
        Select Date Range
      </div>

      <div style={{ fontSize: 12, color: "#999", marginBottom: 4 }}>
        Start Date — End Date
      </div>

      <RangePicker
        style={{ width: "100%" }}
        value={selectedKeys && selectedKeys.length === 2 ? selectedKeys : null}
        onChange={handleChange}
        format="YYYY-MM-DD"
        placeholder={["YYYY-MM-DD", "YYYY-MM-DD"]}
        allowClear
        suffixIcon={null}
      />

      {/* Show preview of selected dates - FIXED: Added safe check for format method */}
      {selectedKeys && selectedKeys.length === 2 && (
        <div style={{ 
          marginTop: 8, 
          padding: "6px 10px", 
          background: "#f5f5f5", 
          borderRadius: 4,
          fontSize: 13,
          color: "#333",
          display: "flex",
          justifyContent: "space-between"
        }}>
          <span>📅 From</span>
          <span style={{ fontWeight: 500 }}>
            {selectedKeys[0]?.format ? selectedKeys[0].format("YYYY-MM-DD") : selectedKeys[0]} — {selectedKeys[1]?.format ? selectedKeys[1].format("YYYY-MM-DD") : selectedKeys[1]}
          </span>
        </div>
      )}

      <Divider style={{ margin: "12px 0" }} />

      <Space style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Button
          icon={<ReloadOutlined />}
          size="small"
          onClick={handleReset}
        >
          Reset
        </Button>

        <Button
          type="primary"
          icon={<FilterOutlined />}
          size="small"
          onClick={handleApply}
          disabled={isDisabled}
        >
          Apply
        </Button>
      </Space>

      {isDisabled && (
        <div style={{ marginTop: 6, fontSize: 11, color: "#ff4d4f" }}>
          Please select both start and end date
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;